import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useRegionById} from '../../../../entities';

interface DeleteRegionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  regionId: string;
}

export const DeleteRegionModal = ({open, setOpen, regionId}: DeleteRegionModalProps) => {
  const {deleteRegionMutation} = useRegionById(regionId);

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление региона',
    title: 'Ошибка при удалении региона',
  });

  useEffect(() => {
    if (deleteRegionMutation.error) {
      handleError(deleteRegionMutation.error as unknown as ApiError);
    }
  }, [deleteRegionMutation.error, handleError]);

  const handleSubmit = () => {
    deleteRegionMutation.mutate(regionId, {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteRegionMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление региона'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этот регион? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
